import {getSiteUrl} from "@/helpers/functions";

export interface PaginationLinksProps {
    slug: string;
    currentPage: number;
    totalPages: number;
    basePath: string;
}

const buildPageUrl = (basePath: string, slug: string, page: number): string => {
    const root = `${basePath}/${slug}`;
    return page <= 1 ? root : `${root}/${page}`;
};

export function PaginationLinks({slug, currentPage, totalPages, basePath}: PaginationLinksProps) {
    if (totalPages <= 1) return null;
    const siteUrl = getSiteUrl();
    const prev = currentPage > 1 ? `${siteUrl}${buildPageUrl(basePath, slug, currentPage - 1)}` : null;
    const next = currentPage < totalPages ? `${siteUrl}${buildPageUrl(basePath, slug, currentPage + 1)}` : null;

    return (
        <>
            {prev && <link rel="prev" href={prev} />}
            {next && <link rel="next" href={next} />}
        </>
    );
}
